import { defineStore } from 'pinia';
import subscriptionStateApi from '../api/johnnyCash';

interface State {
  hasActiveCashflow: boolean,
}

export const useRiseupAccountStore = defineStore('riseupAccount', {
  state: (): State => ({
    hasActiveCashflow: false,
  }),
  actions: {
    async init(): Promise<void> {
      this.hasActiveCashflow = await subscriptionStateApi.hasActiveCashflow();
    },
  },
});
